import { Account } from '@/api/generated/model';
import { AccountDetails } from '@/components/accounts/AccountDetails';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useLanguage } from '@/i18n/LanguageContext';

interface AccountDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  account: Account | null;
  onEdit: () => void;
  onDelete: () => void;
  onRefreshBalance: () => void;
}

export function AccountDetailsDialog({
  open,
  onOpenChange,
  account,
  onEdit,
  onDelete,
  onRefreshBalance,
}: AccountDetailsDialogProps) {
  const { t } = useLanguage();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>{t('accounts.details.title')}</DialogTitle>
          <DialogDescription>{t('accounts.details.description')}</DialogDescription>
        </DialogHeader>
        {account && (
          <AccountDetails
            account={account}
            onEdit={onEdit}
            onDelete={onDelete}
            onRefreshBalance={onRefreshBalance}
          />
        )}
      </DialogContent>
    </Dialog>
  );
}
